import React, { useEffect, useState } from 'react';
import { Route, Redirect, Navigate, RouteComponent } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useAuthState } from 'react-firebase-hooks/auth';

import Loader from 'Loader';

import { useContext } from "react";
import { UserContext } from "App";

const AdminRoute = ({ children }) => {
    const User = useContext(UserContext)
    console.log("UserData in AdminRoute", User)
 
    const auth = getAuth();
    const [user, loading, error] = useAuthState(auth);
  
    const loaderType = "balls"
    const loaderColor = "black"

    if(loading){

        return <Loader type={loaderType} color={loaderColor}/>
    }
    else{
        if(user){
            if(!User) {
                return <div>User data not loaded. Please Refresh.</div>;
            }
            if(User.isActivated === false){
                return <div>You are not active</div>
            }
            else if(User.isSoftDeleted === true){
                return <div>You are soft deleted</div>
            }
            else if(User.userType ==="UnAssigned"){
                return <div>You are unassigned</div>
            }
            else if(User.userType == "Admin" || User.userType == "AccountingEmployee"){
                return (children)
            }
            else{
            return <div>ACCESS DENIED</div>
            }
        }
        else{
            return <Navigate to="/authentication/sign-in"/>
        }
    }

}

export default AdminRoute;
